// Responsive configuration for background images
export const RESPONSIVE_CONFIG = {
  mobile: { width: 400, height: 44, blur: 20, quality: 70 },
  tablet: { width: 600, height: 65, blur: 20, quality: 75 },
  desktop: { width: 757, height: 82, blur: 20, quality: 80 },
} as const;

// Image quality settings
export const IMAGE_QUALITY = {
  placeholder: 10,
} as const;

// CSS classes for styling
export const CSS_CLASSES = {
  container: {
    base: 'light:hidden pointer-events-none absolute inset-0 lg:rounded-b-md',
    mask: '[-webkit-mask-image:linear-gradient(rgba(0,0,0,0)_0%,rgba(0,0,0,.15)_25%,rgba(0,0,0,0)_100%)]',
    maskMd:
      'md:[-webkit-mask-image:linear-gradient(60deg,rgba(0,0,0,.2)_15%,rgba(0,0,0,0)_100%)]',
    transition: 'transition-opacity delay-75 duration-[2s] ease-in-out',
  },
  placeholder: 'absolute inset-0 object-cover blur-sm',
  mainImage: 'z-1 size-full object-cover blur-md',
  noImage:
    'pointer-events-none absolute inset-0 bg-gradient-to-tr from-legacy-spacegray to-legacy-noir lg:rounded-b-md',
} as const;

// Helper functions
export const hasValidImage = (src: string): boolean => {
  return Boolean(src && src.trim() !== '');
};

export const createResponsiveBreakpoints = () => [
  // Mobile
  {
    width: RESPONSIVE_CONFIG.mobile.width,
    height: RESPONSIVE_CONFIG.mobile.height,
    quality: RESPONSIVE_CONFIG.mobile.quality,
    blur: RESPONSIVE_CONFIG.mobile.blur,
  },
  // Tablet
  {
    width: RESPONSIVE_CONFIG.tablet.width,
    height: RESPONSIVE_CONFIG.tablet.height,
    quality: RESPONSIVE_CONFIG.tablet.quality,
    blur: RESPONSIVE_CONFIG.tablet.blur,
  },
  // Desktop
  {
    width: RESPONSIVE_CONFIG.desktop.width,
    height: RESPONSIVE_CONFIG.desktop.height,
    quality: RESPONSIVE_CONFIG.desktop.quality,
    blur: RESPONSIVE_CONFIG.desktop.blur,
  },
];
